export var FNO_BAN = "FNO_BAN";
export var FNO_BAN_MSG = "FNO_BAN_MSG";
export var FNO_BAN_CLEAR_MSG = "FNO_BAN_CLEAR_MSG";
export var FNO_BAN_ERROR = "FII_DII_ERROR";
export var FNO_BAN_HIDE_ERROR = "FNO_BAN_HIDE_ERROR";
export var FNO_BAN_START_LOADER = "FNO_BAN_START_LOADER";
export var FNO_BAN_STOP_LOADER = "FNO_BAN_STOP_LOADER";
